import {
  textUI,
  textSchema,
  phoneUI,
  phoneSchema,
  titleUI,
} from 'platform/forms-system/src/js/web-component-patterns';
// import React
import React from 'react';

export const PrefillAlert = () => (
  <>
    <va-alert status="info">
      <h4 slot="headline">We've prefilled some of your information</h4>
      <p className="vads-u-margin-y--0">
        Because you're on our list of pre-existing state or tribal burial benefit recipients, 
        we were able to prefill some of the information on this page. You can make changes before continuing.
      </p>
    </va-alert>
    <p>This is the organization who will be receiving the interment allowance.</p>
  </>
)

export const NoPrefillAlert = () => (
  <>
    <va-alert
      status="info"
    >
      <h4 slot="headline">
        We were unable to prefill your information
      </h4>
      <p className="vads-u-margin-y--0">
        We couldn't find your information on the pre-approved list of burial organizations. 
        You can continue to add your information manually if you think this is an error. 
        To be added to the pre-approved list please email <a href="mailto:PensionCtrVSO.VBAPHI@va.gov">PensionCtrVSO.VBAPHI@va.gov</a>.
      </p>
    </va-alert>
    <p>This is the organization who will be receiving the interment allowance.</p>
  </>
)

export const burialBenefitsRecipientPage = {
  uiSchema: {
    ...titleUI('VA interment allowance benefits recipient'),
    'ui:description': ({ formData }) => {
      if (!formData?.['view:form530aCemeteryPrefill']) {
        return <p>This is the organization who will be receiving the interment allowance.</p>;
      }
      if (formData?.['view:prefilledOrganization'] === true) {
        return <PrefillAlert/>;
      }
      return <NoPrefillAlert/>;
    },
    burialInformation: {
      recipientOrganization: {
        name: textUI('Name of State Cemetery or Tribal Organization'),
        phoneNumber: phoneUI('Phone number'),
      },
    },
  },
  schema: {
    type: 'object',
    properties: {
      burialInformation: {
        type: 'object',
        properties: {
          recipientOrganization: {
            type: 'object',
            required: ['name', 'phoneNumber'],
            properties: {
              name: textSchema,
              phoneNumber: phoneSchema,
            },
          },
        },
      },
    },
  },
};
